/* S12 scroll-reveal — IntersectionObserver, transform-only, no layout shift */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('jk-revealed');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  function init() {
    document.querySelectorAll('.jk-reveal').forEach(function (el) { obs.observe(el); });
    // Auto-tag select premium sections (opt-in selectors)
    document.querySelectorAll('.jet-nj__values .jet-nj__value-tile, .jet-nj__certs .jet-nj__cert, .jet-trust-strip, .jet-stats-bar').forEach(function (el) {
      el.classList.add('jk-reveal');
      obs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
